import { UnpayActionContext } from "./UnpayActionContext";
import usePrepareUnpay from "./usePrepareUnpay";
import useUnpay from "./useUnpay";
import { useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";

function useUnpayAction(modelConfig: any, index: any): any {
  const prepareUnpay = usePrepareUnpay();
  const prepareUnpayFunction = (id: any) => prepareUnpay(id);

  const onSuccessUnpay = () => {
    setShowModal(false);
    index();
  };

  const pay = useUnpay(modelConfig);

  const payFunction = () => pay(onSuccessUnpay);

  const contextInstance = useContext(UnpayActionContext);
  const { setShowModal } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "unpay",
    onSubmit: () => payFunction(),
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      {t(`are_you_sure_you_want_to_un_pay_this_${modelConfig.modelName}?`)}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareUnpayFunction,
    actionTemplate,
  };
}

export default useUnpayAction;
